// Copyright (c) 2016 Wildcard Corp. www.wildcardcorp.com

import {Injectable} from '@angular/core';
import {Http, Response, Headers} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/Rx';

import {Campaign} from '../models/campaign';

@Injectable()
export class DataService {

  constructor (private http: Http) {}

  // General Data Methods

  getCategories() {
    return ['Arts & Culture', 'Animals', 'Business', 'Charity','Community', 'Education',
            'Emergencies', 'General', 'Children & Family', 'Fashion', 'Food', 'Video Games',
            'Medical', 'Music', 'Other', 'Photography', 'Sports', 'Technology', 'Travel'];
  }

  getTypes() {
    // return ['Fundraising', 'Crowdfunding', 'Event'];
    return ['Fundraising', 'Event'];
  }

  getCurrencyTypes() {
    return ['USD', 'EUR', 'AUD', 'BRL', 'CAD', 'CZK', 'DKK', 'HKD','HUF', 'ILS', 'JPY', 'MYR',
            'MXN', 'TWD', 'NZD', 'NOK', 'PHP', 'PLN', 'GBP', 'RUB', 'SGD', 'SEK', 'CHF', 'THB'];
  }

  getTimezones() {
    return ['US/Alaska', 'US/Central', 'US/Eastern', 'US/Hawaii', 'US/Mountain', 'US/Pacific'];
  }

  getCountries() {
    return ["United States", "United Kingdom", "Germany", "Mexico", "Russia", "China", "Spain", "Afghanistan",
            "Albania", "Algeria", "American Samoa",  "Angola", "Anguilla", "Antartica", "Antigua and Barbuda",
            "Argentina", "Armenia", "Aruba", "Ashmore and Cartier Island", "Australia", "Austria", "Azerbaijan",
            "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan",
            "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "British Virgin Islands", "Brunei",
            "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands",
            "Central African Republic", "Chad", "Chile", "Christmas Island", "Clipperton Island",
            "Cocos (Keeling) Islands", "Colombia", "Comoros", "Cook Islands", "Costa Rica", "Croatia", "Cyprus",
            "Czeck Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt",
            "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Europa Island",
            "Falkland Islands (Islas Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana",
            "French Polynesia", "French Southern and Antarctic Lands", "Gabon", "Gambia, The", "Gaza Strip",
            "Georgia", "Ghana", "Gibraltar", "Glorioso Islands", "Greece", "Greenland", "Grenada",
            "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti",
            "Heard Island and McDonald Islands", "Holy See (Vatican City)", "Honduras", "Hong Kong",
            "Howland Island", "Hungary", "Iceland", "India", "Indonesia", "Ireland", "Ireland, Northern",
            "Israel", "Italy", "Jamaica", "Jan Mayen", "Japan", "Jarvis Island", "Jersey", "Johnston Atoll",
            "Jordan", "Juan de Nova Island", "Kazakhstan", "Kenya", "Kiribati", "Korea, North", "Korea, South",
            "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Libya", "Liechtenstein", "Lithuania",
            "Luxembourg", "Macau", "Macedonia, Former Yugoslav Republic of", "Madagascar", "Malawi", "Malaysia",
            "Maldives", "Mali", "Malta", "Man, Isle of", "Marshall Islands", "Martinique", "Mauritania", "Mauritius",
            "Mayotte", "Micronesia, Federated States of", "Midway Islands", "Moldova", "Monaco", "Mongolia",
            "Montserrat", "Morocco", "Mozambique", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles",
            "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island",
            "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", "Paraguay", "Peru",
            "Philippines", "Pitcaim Islands", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romainia",
            "Rwanda", "Saint Helena", "Saint Kitts and Nevis", "Saint Lucia", "Saint Pierre and Miquelon",
            "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia",
            "Scotland", "Senegal", "Seychelles", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia",
            "South Africa", "South Georgia and South Sandwich Islands", "Spratly Islands", "Sri Lanka", "Suriname",
            "Svalbard", "Swaziland", "Sweden", "Switzerland", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Tobago",
            "Toga", "Tokelau", "Tonga", "Trinidad", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda",
            "United Arab Emirates", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Virgin Islands",
            "Wales", "Wallis and Futuna", "West Bank", "Western Sahara", "Yemen", "Yugoslavia", "Zambia"];
  }

  getCountriesDict() {
    return {'United States': 'US', 'Australia': 'AU', 'Austria': 'AT', 'Belgium': 'BE', 'Canada': 'CA', 'Denmark': 'DK',
            'Finland': 'FI', 'France': 'FR', 'Germany': 'DE', 'Hong Kong': 'HK', 'Ireland': 'IE', 'Japan': 'JP', 'Luxembourg':
            'LU', 'Netherlands': 'NL', 'New Zealand': 'NZ', 'Norway': 'NO', 'Singapore': 'SG', 'Spain': 'ES', 'Sweden':
            'SE', 'Switzerland': 'CH', 'United Kingdom': 'GB'}
  }

  getStates() {
    return {'Alabama': 'AL', 'Alaska': 'AK', 'American Samoa': 'AS', 'Arizona': 'AZ', 'Arkansas': 'AR', 'California': 'CA',
            'Colorado': 'CO', 'Connecticut': 'CT', 'Delaware': 'DE', 'District of Columbia': 'DC',
            'Federated States of Micronesia': 'FM', 'Florida': 'FL', 'Georgia': 'GA', 'Guam': 'GU', 'Hawaii': 'HI',
            'Idaho': 'ID', 'Illinois': 'IL', 'Indiana': 'IN', 'Iowa': 'IA', 'Kansas': 'KS', 'Kentucky': 'KY', 'Louisiana': 'LA',
            'Maine': 'ME', 'Maryland': 'MD', 'Massachusetts': 'MA', 'Marshall Islands': 'MH', 'Michigan': 'MI', 'Minnesota': 'MN',
            'Mississippi': 'MS', 'Missouri': 'MO', 'Montana': 'MT', 'Nebraska': 'NE', 'Nevada': 'NV', 'New Hampshire': 'NH',
            'New Jersey': 'NJ', 'New Mexico': 'NM', 'New York': 'NY', 'Northern Mariana Islands': 'MP', 'North Carolina': 'NC',
            'North Dakota': 'ND', 'Ohio': 'OH', 'Oklahoma': 'OK', 'Oregon': 'OR', 'Palau': 'PW', 'Pennsylvania': 'PA',
            'Puerto Rico': 'PR', 'Rhode Island': 'RI', 'South Carolina': 'SC', 'South Dakota': 'SD', 'Tennessee': 'TN',
            'Texas': 'TX', 'Utah': 'UT', 'Vermont': 'VT', 'Virginia': 'VA', 'Virgin Islands': 'VI', 'Washington': 'WA',
            'West Virginia': 'WV', 'Wisconsin': 'WI', 'Wyoming': 'WY'}
  }

  processGet(url:string) {
    return this.http.get(url)
      .map(response => response.json())
      .catch(this.handleError);
  }

  processPost(post_url: string, post_body: any) {
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return this.http.post(post_url, JSON.stringify(post_body), {headers: headers})
      .map(response => response.json())
      .catch(this.handleError)
  }

  // Payment Methods

  submitPayment(payment_details: {}) {;
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    return this.http.post('/stripe-payment', JSON.stringify(payment_details), {headers: headers})
      .map(res => res)
      .catch((error: Response) => {
        return Observable.throw('Server Error');
      })
  }

  // Account Methods

  accessAccount(userID: string, loginDetails: {}) {
    let headers = new Headers({'Content-Type': 'application/json'});
    return this.http.post('/account_api/' + userID, JSON.stringify(loginDetails), {headers: headers})
      .map(res => {
        try {
          var data = res.json();
          if(data['response'] === "Password Changed Successfully") {
            return {'response': 'success', 'data': data['response']};
          }
          return {'response': 'failure', 'data': data['response']};
        }
        catch (Exception){
          return {'response': 'success', 'data': res.url};
        }
      })
      .catch((error: Response) => {
        return Observable.throw('Server Error');
      });
  }

  // Error Handling

  private handleError (error: Response) {
    console.error(error);
    return Observable.throw(error.json().data || 'Server error');
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./app/services/data.service.ts